"use client";

import React from "react";
import { usePathname } from "next/navigation";

interface ChromeGateProps {
  /** Hide the children when the current path starts with this prefix. */
  hideOnPrefix: string;
  children: React.ReactNode;
}

/**
 * Client-side visibility gate for chrome that lives in the shared
 * `(cms)` layout.
 *
 * Next.js does NOT re-render a shared layout on client-side (soft)
 * navigation, so the org header rendered there can't react to the
 * route on its own — navigating away from a `/dept/*` page would
 * otherwise leave the department header (or, conversely, keep the org
 * header on a dept page). This gate reads the live `usePathname()` and
 * hides its children on the matching prefix, so the org masthead
 * disappears the instant the user enters a department zone and comes
 * back the instant they leave — no full reload required.
 *
 * The matching department header itself is rendered by the nested
 * `dept/[dept]/layout.tsx`, which DOES re-render per route on soft nav.
 */
export function ChromeGate({ hideOnPrefix, children }: ChromeGateProps) {
  const pathname = usePathname();
  if (pathname && pathname.startsWith(hideOnPrefix)) return null;
  return <>{children}</>;
}

export default ChromeGate;
